import React, { useMemo } from 'react';
import usePropertyPath from '../hooks/usePropertyPath';
import useProperty from '../hooks/useProperty';
import WizardSelectControlledComponent from 'components/v2/epd-wizard-inputs/WizardSelectControlled';
import useDataSource from '../hooks/useDataSource';

interface Props {
  propertyId: string;
  label: string;
  tooltip: string;
}

// This is pretty much a unique component.
// I don't want to introduce another property type just for this single use case.
// Therefore currently it's declared as an array of objects with 'id' enum.
const StandardsSelectorRenderer: React.FC<Props> = ({ propertyId, label, tooltip }) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<{ id: string }[]>(propertyPath);

  const standardsIdPath = useMemo(() => [...propertyPath, 0, 'id'], [propertyPath]);
  const { options } = useDataSource(standardsIdPath);

  if (!isVisible) {
    return null;
  }

  return (
    <WizardSelectControlledComponent
      name={propertyId}
      options={options}
      value={options.filter((o) => value.some((v) => v.id === o.value))}
      label={label}
      tooltip={tooltip}
      onChanged={(_: string, value: string[]) => {
        setValue(value.map((id) => ({ id })));
      }}
      error={errorMessage}
      disabled={isDisabled}
      isMulti
    />
  );
};

export default StandardsSelectorRenderer;
